import React, { useCallback } from 'react';
import Button from '@atlaskit/button';

import { useIntlV2 as useIntl } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import type { UIAnalyticsEvent } from '@atlassian/jira-product-analytics-bridge';
import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type { ChildIssuesPanelType } from '../../../common/types.tsx';
import { generateBulkEditLink } from '../../heading/meatballs/src/utils.tsx';
import { useChildIssuesSortBy } from '../../../controllers/main.tsx';
import { BULK_EDIT_BUTTON_TEST_ID } from '../constants/index.tsx';
import messages from './messages.tsx';

type Props = {
	hasExceededIssuesLimitInitialLoad: boolean;
	childIssuesPanelType: ChildIssuesPanelType;
	parentKey: IssueKey;
	onBulkEditClicked: (issueCount: number | string, analyticsEvent: UIAnalyticsEvent) => void;
	visibleIssuesCount: string;
};

export const BulkEditButton = ({
	hasExceededIssuesLimitInitialLoad,
	childIssuesPanelType,
	parentKey,
	onBulkEditClicked,
	visibleIssuesCount,
}: Props) => {
	const { formatMessage } = useIntl();

	const [sortByValue] = useChildIssuesSortBy();

	const bulkEditLink = generateBulkEditLink(
		parentKey,
		childIssuesPanelType,
		hasExceededIssuesLimitInitialLoad,
		sortByValue || undefined,
	);
	const onBulkEditClickedAnalytics = useCallback(
		(issueCount: number | string) => (analyticsEvent: UIAnalyticsEvent) => {
			onBulkEditClicked(issueCount, analyticsEvent);
		},
		[onBulkEditClicked],
	);

	return (
		<Button
			appearance="default"
			href={bulkEditLink}
			// @ts-expect-error Type '(analyticsEvent: AnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>) => void'.
			onClick={onBulkEditClickedAnalytics(visibleIssuesCount)}
			testId={BULK_EDIT_BUTTON_TEST_ID}
			interactionName="auto-generated.jira-issue-view-common-views.child-issues-panel.view.child-issues-limit-panel.button.bulk-edit"
		>
			{formatMessage(messages.bulkEditButton)}
		</Button>
	);
};
